import InvalidSelectorError from "../../../../../../util/errors/InvalidSelectorError.js";
export default class InvalidJsonSchema$anchorError extends InvalidSelectorError {
  constructor(anchor) {
    super(`Invalid JSON Schema $anchor "${anchor}".`);
  }
}